import { create } from "zustand";

export const emptyAccountState = {
  accountId: "",
  error: "",
  info: [],
  loaded: false,
  loading: false,
  logoError: "",
  logoLoading: false,
  logoUrl: "",
  planName: "",
  profile: null,
};

export const emptyUsersState = {
  actionError: "",
  actionLoading: false,
  error: "",
  limits: null,
  loaded: false,
  loading: false,
  permissionModules: [],
  roles: [],
  saving: false,
  users: [],
};

export const emptyQuotasState = {
  error: "",
  loaded: false,
  loading: false,
  quotas: null,
};

export const emptyEntitlementsState = {
  entitlements: null,
  error: "",
  loaded: false,
  loading: false,
};

function resolveUpdate(current, updater) {
  return typeof updater === "function" ? updater(current) : updater;
}

function createInitialAccountSettingsState() {
  return {
    accountState: {
      ...emptyAccountState,
      info: [],
    },
    usersState: {
      ...emptyUsersState,
      permissionModules: [],
      roles: [],
      users: [],
    },
    quotasState: {
      ...emptyQuotasState,
    },
    entitlementsState: {
      ...emptyEntitlementsState,
    },
  };
}

const useAccountSettingsStore = create((set) => ({
  ...createInitialAccountSettingsState(),

  setAccountState: (updater) =>
    set((state) => ({
      accountState: resolveUpdate(state.accountState, updater),
    })),

  setUsersState: (updater) =>
    set((state) => ({
      usersState: resolveUpdate(state.usersState, updater),
    })),

  setQuotasState: (updater) =>
    set((state) => ({
      quotasState: resolveUpdate(state.quotasState, updater),
    })),

  setEntitlementsState: (updater) =>
    set((state) => ({
      entitlementsState: resolveUpdate(state.entitlementsState, updater),
    })),

  resetAccountSettingsState: () => set(createInitialAccountSettingsState()),
}));

export default useAccountSettingsStore;
